/**
 * This file holds the messges to be shown for the user at different scenarios. i18n is not part of this project scope.
 * So, single language critical/generic messages are only maintained here.
 */
export const Messages = {
    service: {
        dataNF : 'No matching data found for the request. Please try other filters.',
        errorCode0 : 'Could not process your request at this moment. Please, try after sometime.', // This happens on timeout, CORS error,
        errorCode400 : 'Invalid request or session expired. Please refresh the page and login again.',
        errorCode401 : 'You don\'t have enough permission to perfom this. Please, contact system administrator.',
        errorCode404 : 'Requested information is not available or moved somewhere',
        errorCode413 : 'File size is too large. Please upload a file smaller than 1 MB.',
        errorCode500 : 'Server couldn\'t process your request at this time. Please, try after sometime.',
    },
    local: {
        serviceCallFail : 'Could not process your request at this moment. Please, try after sometime.'
    },
    userInfo: {
        refresh: 'Refreshing the details',
        allMandatoryField: 'Please, fill in the mandatory fields and try loading for data'
    },
};
